// @flow

import type {
  AuthState,
} from '../../types'

export default function eulaSigned$ (state: { auth: AuthState }): boolean {
  return {
    eulaSigned: state.auth.eulaSigned,
    isFetchingEulaSigned: state.auth.isFetchingEulaSigned,
  }
}
